import {POSITION_START} from './positionStartTypes'

export const changepositionStart = positionStart => {
    return {
        type: POSITION_START,
        load: positionStart
    }
}

export const selectNewPositionStart = (positionStart) => {

    return (dispatch) => {
        dispatch(changepositionStart(positionStart))
    }

}